import { Accordion } from '../../Accordion/Accordion';

type FaqItem = {
  question: string;
  answer: string;
};

type LotteryFaqAccordionProps = {
  items: readonly FaqItem[];
};

function LotteryFaqAccordion({ items }: LotteryFaqAccordionProps) {
  return (
    <div className="w-full" data-track-container="FAQs">
      {items.map(item => (
        <Accordion key={item.question} className="border-b border-border" name="faq-item" data-track-name="FAQ" data-track-title={item.question} data-track-answer={item.answer}>
          <Accordion.Summary className="py-4.5">
            <h2 className="paragraph-strong text-foreground">{item.question}</h2>
          </Accordion.Summary>
          <Accordion.Content information={item.answer} tag="div" className="lottery-faq-content paragraph flex flex-col gap-3" />
        </Accordion>
      ))}
    </div>
  );
}

export { LotteryFaqAccordion, type LotteryFaqAccordionProps };
